<!--error-notification *ngIf="showError" [errorTitle]="errorTitle" [errorMessage]="errorMessage" (onRetry)="retry()"></error-notification-->

@if (!((store.value$ | async)?.error)) {
  <div class="applications-page container-fluid">
    @if (this.promo?.showMessage==true) {
      <div class="promo">
        <message-box type="promo-style2" [url]="this.promo?.link||''" (close)="closePromo($event)">{{this.promo?.message}}</message-box>
      </div>
    }
    <div class="promo">
      <message-box type="info" (close)="closePromo($event)" [showRefresh]="true" (onRefresh)="refresh(true)">{{lastUpdatedMessage}}</message-box>
    </div>
    <div class="header-bar">
      <div class="row" style="margin: 0;" fxLayoutAlign="space-between center">
        <div class="col-md-3 mb-2">
          <mat-card class="status-card background-dark" (click)="onApplicationStageFilter(STAGE_NAMES_UNDER_REVIEW)">
            <mat-card-content>
              <div class="status-label">
                Under Review
              </div>
              <div class="status-value mt-2">
                {{totalApplicationsUnderReview}}
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3 mb-2">
          <mat-card class="status-card background-blue" (click)="onApplicationStageFilter(STAGE_NAMES_APPROVED)">
            <mat-card-content>
              <div class="status-label">
                Approved
              </div>
              <div class="status-value mt-2">
                {{totalApplicationsApproved}}
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3 mb-2">
          <mat-card class="status-card background-teal" (click)="onApplicationStageFilter(STAGE_NAMES_IN_SETTLEMENT)">
            <mat-card-content>
              <div class="status-label">
                In Settlement
              </div>
              <div class="status-value mt-2">
                {{totalApplicationsInSettlement}}
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-3 mb-2">
          <mat-card class="status-card background-green" (click)="onApplicationStageFilter(STAGE_NAMES_CLOSED_WON)">
            <mat-card-content>
              <div class="status-label">
                Closed Won
              </div>
              <div class="status-value mt-2">
                {{totalApplicationsClosedWon}}
              </div>
            </mat-card-content>
          </mat-card>
          </div>
        </div>
    
      <div class="row filters-row">
        <mat-form-field subscriptSizing="dynamic" class="search">
          <input [formControl]="searchControl" matInput #searchText class="ml-1" type="text" placeholder="Search by ID or name">
          <span class="mdi mdi-magnify" matPrefix></span>
        </mat-form-field>
        <div class="filter-buttons">
          @if(!showMyApplications){
            <button mat-flat-button [disabled]="disabled" [color]="toggleMyApplicationsBtn ? 'primary' : 'default'"  (click)="toggleMyApplications()">My Applications</button>
          }
          <data-box title="Filters" type="green" [icon]="showFilters ? 'chevron-down' : 'chevron-up'" data="{{selectedFiltersCount == 0 ? undefined : selectedFiltersCount}}" (boxClick)="toggleFilters()" [class]="showFilters ? 'filtersOpen' : 'filtersClosed'"/>
          <data-box type="green" icon="close" title="Clear" (boxClick)="clearFilters()" class="clear-button"/>
        </div>
      </div>

      @if (showFilters) {
        <div class="row filters-row">
          <searchable-select 
            [formControl]="applicationTypeControl"
            [items]="applicationTypes"
            [multi]="true"
            [placeholder]="'Application Type'"
            (selectionChange)="selectionChange('applicationType')"
          />
          <searchable-select 
            [formControl]="applicationStageControl"
            [items]="applicationStages"
            [multi]="true"
            [placeholder]="'Application Stage'"
            (selectionChange)="selectionChange('applicationStage')"
          />
          @if (isInternalUser(loggedInUser)) {
            <button class="statistic-button" mat-flat-button (click)="toggleStatistic()">Statistic:&nbsp;&nbsp;&nbsp;&nbsp;{{statisticControl.value}}</button>
          }
        </div>

        @if(isInternalUser(loggedInUser)){
          <applications-graph [formControl]="graphDataFormControl" (onColumnClick)="onColumnClick($event)" [statistic]="statisticControl.value ?? 'Count'"></applications-graph>
        }
        <div class="row filters-row">
          <div class="date-range-box" (mouseenter)="changeDisplayFields(checkCanUseDateRange() ? 'dateRange' : displayFields)" (mouseleave)="changeDisplayFields(null)" (click)="changeDisplayFields('dateRange')">
            @if (displayFields == 'slider') {
              <span class="date-range-text dates">{{sliderDisplayWith(startDateFormControl.value ?? 0)}} - {{sliderDisplayWith(endDateFormControl.value ?? 0)}}</span>
            } @else if (displayFields == 'dateRange') {
              <span class="date-range-text clickable" (click)="onDateRangeClick('24hr')" >24hr</span>
              <span class="date-range-text clickable" (click)="onDateRangeClick('48hr')" >48hr</span>
              <span class="date-range-text clickable" (click)="onDateRangeClick('week')" >Week</span>
              <span class="date-range-text clickable" (click)="onDateRangeClick('month')">Month</span>
              <span class="date-range-text clickable" (click)="onDateRangeClick('year')" >Year</span>
              <span class="date-range-text clickable" (click)="onDateRangeClick('all')"  >All</span>
            } @else {
              <span class="date-range-text">Expand Date Range</span>
            }
          </div>
          <mat-slider 
            [min]="minDate" 
            [max]="MAX_DATE" 
            [step]="24 * 60 * 60 * 1000" 
            class="date-range-slider" 
            (change)="onDateSelect($event)"
          >
            <input matSliderStartThumb [formControl]="startDateFormControl" (mouseenter)="changeDisplayFields('slider')" (mouseleave)="changeDisplayFields(null)">
            <input matSliderEndThumb   [formControl]="endDateFormControl"   (mouseenter)="changeDisplayFields('slider')" (mouseleave)="changeDisplayFields(null)">
          </mat-slider>
        </div>
        
        @if(isInternalUser(loggedInUser)){
          <div class="row filters-row">
            <div class="col contact-box">
              <h4>Sales Contact</h4>
              <section class="section scrollbar" >
                <mat-selection-list [formControl]="filterOpportunityOwnerControl">
                  @if(opportunityOwners.length > 0) {
                    @for (owner  of opportunityOwners; track owner.id) {
                      <mat-list-option
                        (selectedChange)="selectionChange('opportunity')"
                        checkboxPosition="before"
                        [value]="owner.id"
                        class="mat-primary">
                        <span class="selectable-text">{{owner.label}}</span>
                        @if (filterOpportunityOwnerControl.value?.length == 0 || filterOpportunityOwnerControl.value?.includes(owner.id)) {
                          <span class="green">{{owner.count}}</span>
                        }
                      </mat-list-option>
                    }
                  } @else {
                    <mat-list-option disabled checkboxPosition="before">
                      <span class="mat-list-option-text">No Opportunity Owners</span>
                    </mat-list-option>
                  }
                </mat-selection-list>
              </section>  
            </div>
            <div class="col contact-box">
              <h4>Credit Officer</h4>
              <section class="section scrollbar">
                <mat-selection-list [formControl]="filterCreditOfficerControl">
                  @if(creditOfficers.length > 1) {
                    @for (credit  of creditOfficers; track credit.id) {
                      <mat-list-option
                        (selectedChange)="selectionChange('credit')"
                        checkboxPosition="before"
                        [value]="credit.id"
                        class="mat-primary">
                        <span class="selectable-text">{{credit.label}}</span>
                        @if (filterCreditOfficerControl.value?.length == 0 || filterCreditOfficerControl.value?.includes(credit.id)) {
                          <span class="green">{{credit.count}}</span>
                        }
                      </mat-list-option>
                    }
                  } @else {
                    <mat-list-option disabled checkboxPosition="before">
                      <span class="mat-list-option-text">No Credit Officers</span>
                    </mat-list-option>
                  }
                </mat-selection-list>
              </section>
            </div>
            <div class="col contact-box">
              <h4>Settlement Officer</h4>
              <section class="section scrollbar">
                <mat-selection-list [formControl]="filterSettlementOfficerControl">
                  @if(settlementOfficers.length > 0) {
                    @for (settlement of settlementOfficers; track settlement.id) {
                      <mat-list-option
                        (selectedChange)="selectionChange('settlement')"
                        checkboxPosition="before"
                        [value]="settlement.id"
                        class="mat-primary">
                        <span class="selectable-text">{{settlement.label}}</span>
                        @if (filterSettlementOfficerControl.value?.length == 0 || filterSettlementOfficerControl.value?.includes(settlement.id)) {
                          <span class="green">{{settlement.count}}</span>
                        }
                      </mat-list-option>
                    }
                  } @else {
                    <mat-list-option disabled checkboxPosition="before">
                      <span class="mat-list-option-text">No Settlement Officers</span>
                    </mat-list-option>
                  }
                </mat-selection-list>
              </section>
            </div>
          </div>
        }
      }
    </div>
    <div class="row separator-top">
      <div class="col body">
        <div [ngClass]="['table-section', 'pb-3']">
          <div style="height: 10px;">
            <mat-progress-bar class="custom-progress-bar" [ngClass]="{hidden: !isProgressBarVisible}"  mode="indeterminate"></mat-progress-bar>
          </div>
          <table mat-table [dataSource]="dataSource" class="width-100 mb-2" matSort (matSortChange)="onSort($event)">
            <ng-container matColumnDef="appId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>App ID</th>
              <td class="col-app-id" mat-cell *matCellDef="let application">
                <application-type-icon [applicationType]="application.ApplicationType"></application-type-icon> {{application.BrokerAppId}}<br/>
                <span class="date-text">{{getApplicationCreateTime(application)}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="appName">
              <th class="col-appName" mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>App Name</span>
              </th>
              <td mat-cell *matCellDef="let application">
                @if (application.Source == 'external') {
                  <span class="mr-1 mdi mdi-alpha-e-circle" matTooltip="External source application"></span>
                }
                @if (application.Source == 'direct') {
                  <span class="mr-1 mdi mdi-alpha-d-circle" matTooltip="Direct source application"></span>
                }
                {{getApplicantName(application)}}<br/>
                @if (showBrokerName()) {
                  <span class="date-text">{{application.BrokerName}}</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let application">
                <tag-box [state]="getApplicationStatus(application) ?? ''"></tag-box>
              </td>
            </ng-container>
            <ng-container matColumnDef="stage">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Stage</th>
              <td mat-cell *matCellDef="let application">
                <tag-box [state]="getApplicationStage(application)"></tag-box>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="column-width-0"></th>
              <td mat-cell *matCellDef="let application" class="cell">
                
                <span class="mdi mdi-dots-vertical cursor-pointer" (click)="$event.stopPropagation();" [matMenuTriggerFor]="menu"></span>
                
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onApplicationClick($event, application, true)" class="menu-items">
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 150px;">
                      <div style="flex-grow: 1; text-align: left;">Open in New Tab</div>
                        <span class="mdi mdi-open-in-new"></span>
                    </div>
                  </button>
                  @if (application.Status == 'Draft') {
                    <button mat-menu-item (click)="onDelete(application.ApplicationId)"  class="menu-items">
                      <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 150px;">
                        <div style="flex-grow: 1; text-align: left;">Delete</div>
                        <div><span class="mdi mdi-trash-can-outline"></span></div>
                      </div>
                    </button>
                  }
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr class="cursor-pointer" (click)="onApplicationClick($event, application, false)" mat-row *matRowDef="let application; columns: displayColumns"></tr>
          </table>
          @if (total) {
            <app-custom-paginator
              [length]="total" [pageIndex]="offset" [pageSize]="limit"
            [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)"></app-custom-paginator>
          }
          <div class="footnote mat-caption mt-2"
            fxLayoutAlign.lt-sm="center center">
            Only applications in the last 12 months are listed
          </div>
          <div class="footnote mdi mdi-magnify mat-caption cursor-pointer mt-2"
            fxLayoutAlign.lt-sm="center center" (click)="onClickAllApplication($event)">
            <u>Search for older applications</u>
          </div>
        </div>
      </div>
    </div>
  </div>
}
